import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { ApiServiceConfig, HexaApiService } from "@hexalang/ui/core";
import { CityApiServiceConfig } from "../models/api-service-config.model";
import { CITY_API_SERVICE_CONFIG_TOKEN } from "@city-tax/core";


@Injectable({
  providedIn: "root"
})
export class CityApiService extends HexaApiService {
  public city: string = "";
  public state: string = "";

  constructor(
    @Inject(CITY_API_SERVICE_CONFIG_TOKEN) config: CityApiServiceConfig,
    http: HttpClient
  ) {
    // console.log("CityApiService config:", config);
    super(config as ApiServiceConfig, http);
    if (config) {
      this.city = config.city;
      this.state = config.state;
    }
  }
}
